module.exports = __webpack_public_path__ + "img/distanceWedge7.5c86cfac.png";